// Literal, case-insensitive highlighting. Returned strings are always text nodes.
export function splitHighlightedText(value, keyword) {
  const text = value == null ? '' : String(value)
  const term = keyword == null ? '' : String(keyword)
  if (!term || !text) return [{ text, highlight: false }]
  const escaped = Array.from(term).map(char => '\\^$.*+?()[]{}|'.indexOf(char) >= 0 ? '\\' + char : char).join('')
  let matcher
  try {
    matcher = new RegExp(escaped, 'gi')
  } catch (error) {
    return [{ text, highlight: false }]
  }
  const parts = []
  let cursor = 0
  let match
  while ((match = matcher.exec(text)) !== null) {
    if (match.index > cursor) parts.push({ text: text.slice(cursor, match.index), highlight: false })
    parts.push({ text: match[0], highlight: true })
    cursor = match.index + match[0].length
  }
  if (cursor < text.length) parts.push({ text: text.slice(cursor), highlight: false })
  return parts.length ? parts : [{ text, highlight: false }]
}
